import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: '#f9f9fc',
    "& .MuiFormControl-root": {
      margin: 0
    },
    "& .MuiInputBase-root": {
      padding: 0,
    }
  },
  prefixWrapper: {
    backgroundColor: theme.palette.grey.grey200,
    borderRadius: '12px 0 0 12px',
    padding: "7px 10px",
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    maxWidth: "200px",
    "& .MuiTypography-root": {
      color: theme.palette.grey.grey500,
      fontWeight: 400,
      whiteSpace: 'nowrap',
      lineHeight: '140%',
      fontStyle: 'normal',
      fontSize: '14px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  inputField: {
    flex: 2,
    "& .MuiInputBase-root": {
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-root': {
      padding: 0,
      fontSize: '0.95rem',
    },
  }
}));

export default useStyles;